import { createActions } from 'redux-actions';

export default createActions({
  SEARCH_VIDEOS: undefined,
  SEARCH_VIDEOS_FAILED: undefined,
  TOGGLE_BOOLEAN: undefined,
  RESET_STATE: undefined,
});
